module.exports = __webpack_public_path__ + "img/error.03eef8dd.svg";